"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jquery = _interopRequireDefault(require("jquery"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "borderMargin", 30);
    _defineProperty(_assertThisInitialized(_this), "state", {
      topOpacity: 0,
      bottomOpacity: 0
    });
    _defineProperty(_assertThisInitialized(_this), "onScroll", function (e) {
      var _this$wrapper = _this.wrapper,
        scrollHeight = _this$wrapper.scrollHeight,
        scrollTop = _this$wrapper.scrollTop,
        clientHeight = _this$wrapper.clientHeight;
      var topOpacity = Math.min(scrollTop / _this.borderMargin, 1);
      var bottom = scrollHeight - (scrollTop + clientHeight);
      var bottomOpacity = Math.min(bottom / _this.borderMargin, 1);
      if (topOpacity === _this.state.topOpacity && bottomOpacity === _this.state.bottomOpacity) {
        return;
      }
      _this.setState({
        topOpacity: topOpacity,
        bottomOpacity: bottomOpacity
      });
    });
    _defineProperty(_assertThisInitialized(_this), "scrollToNode", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        nodeId = _ref.nodeId;
      var marginTop = 15;
      var wrapper = (0, _jquery["default"])(_this.wrapper);
      var element = wrapper.find("#".concat(nodeId)).first();
      if (!element.length) {
        return;
      }
      var borderTop = element.offset().top - wrapper.offset().top;
      var borderBottom = borderTop + element.height();

      // If the element is visible then don't scroll
      if (borderTop >= 0 && borderBottom <= _this.wrapper.clientHeight) {
        return;
      }
      var position;
      if (borderTop < 0) {
        position = _this.wrapper.scrollTop + borderTop - marginTop;
      } else if (borderBottom > _this.wrapper.clientHeight) {
        position = Math.min(_this.wrapper.scrollTop + borderTop - marginTop, _this.wrapper.scrollTop + (borderBottom - _this.wrapper.clientHeight) + marginTop);
      }
      wrapper.animate({
        scrollTop: position
      }, 200);
    });
    return _this;
  }
  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.wrapper.addEventListener('scroll', this.onScroll);
      this.onScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.wrapper.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        topOpacity = _this$state.topOpacity,
        bottomOpacity = _this$state.bottomOpacity;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, this.props, {
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          position: 'relative',
          overflow: 'visible'
        })
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].top,
        style: {
          opacity: topOpacity
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].bottom,
        style: {
          opacity: bottomOpacity
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(node) {
          _this2.wrapper = node;
        },
        className: _style["default"].body
      }, this.props.children));
    }
  }]);
  return Component;
}(_react["default"].Component);
exports["default"] = Component;
_defineProperty(Component, "propTypes", {
  children: _propTypes["default"].node,
  style: _propTypes["default"].object
});